import { Box, Button, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";

import GetAppIcon from "@mui/icons-material/GetApp";
import { defaultTemplate, generateExcel } from "./PurchaseTemplateGenerator ";
import { useGetCodeTranslationQuery, useListPlaceOfSupplyQuery } from "../../redux/apis/getCodeTranslation.api";
import { useListGroupMasterQuery } from "../../redux/apis/accountGroupMaster.api";
import {
  addDropdowns,
  addTable,
  applyStyling,
  createWorkbook,
  downloadWorkbook,
} from "./ImportTemplate";
import { useSelector } from "react-redux";
import { API, graphqlOperation } from "aws-amplify";
import { getCompanyCodeTranslation, getPartyAccountData } from "../../graphql";
import { useGetCompanyCodeTranslationQuery } from "../../redux/apis/getCompanyCodeTranslation.api";
import { billingCurrencyOptions } from "../../utils/Data/StaticData";
import { useListAccountMasterv2Query } from "../../redux/apis/accountMaster.api";
import { showWarningSnackbar } from "../snackBar/snakbar";


function TemplateGenerator({ module, fields, format }) {

   const { data: stateList, isSuccess: stateListSuc } =
      useGetCodeTranslationQuery(
        { codetype:"IndiaState" },
      );

   const { data: countriesList } = useGetCodeTranslationQuery({
      codetype: "Country",
    });
  const { data: listOfStates } = useListPlaceOfSupplyQuery({ codetype: "IndiaState" })

  const { data: allGroups } = useListGroupMasterQuery();

  const [lessTds, setLessTds] = useState([]);
  const [tdsData, setTdsData] = useState([]);

 
 const country =  [
    { "code": "AF", "name": "Afghanistan", "dialCode": "+93" },
    { "code": "AL", "name": "Albania", "dialCode": "+355" },
    { "code": "DZ", "name": "Algeria", "dialCode": "+213" },
    { "code": "AD", "name": "Andorra", "dialCode": "+376" },
    { "code": "AO", "name": "Angola", "dialCode": "+244" },
    { "code": "AR", "name": "Argentina", "dialCode": "+54" },
    { "code": "AM", "name": "Armenia", "dialCode": "+374" },
    { "code": "AU", "name": "Australia", "dialCode": "+61" },
    { "code": "AT", "name": "Austria", "dialCode": "+43" },
    { "code": "AZ", "name": "Azerbaijan", "dialCode": "+994" },
    { "code": "BH", "name": "Bahrain", "dialCode": "+973" },
    { "code": "BD", "name": "Bangladesh", "dialCode": "+880" },
    { "code": "BY", "name": "Belarus", "dialCode": "+375" },
    { "code": "BE", "name": "Belgium", "dialCode": "+32" },
    { "code": "BZ", "name": "Belize", "dialCode": "+501" },
    { "code": "BJ", "name": "Benin", "dialCode": "+229" },
    { "code": "BO", "name": "Bolivia", "dialCode": "+591" },
    { "code": "BA", "name": "Bosnia and Herzegovina", "dialCode": "+387" },
    { "code": "BR", "name": "Brazil", "dialCode": "+55" },
    { "code": "BG", "name": "Bulgaria", "dialCode": "+359" },
    { "code": "CA", "name": "Canada", "dialCode": "+1" },
    { "code": "CL", "name": "Chile", "dialCode": "+56" },
    { "code": "CN", "name": "China", "dialCode": "+86" },
    { "code": "CO", "name": "Colombia", "dialCode": "+57" },
    { "code": "HR", "name": "Croatia", "dialCode": "+385" },
    { "code": "CU", "name": "Cuba", "dialCode": "+53" },
    { "code": "CY", "name": "Cyprus", "dialCode": "+357" },
    { "code": "CZ", "name": "Czech Republic", "dialCode": "+420" },
    { "code": "DK", "name": "Denmark", "dialCode": "+45" },
    { "code": "DO", "name": "Dominican Republic", "dialCode": "+1" },
    { "code": "EC", "name": "Ecuador", "dialCode": "+593" },
    { "code": "EG", "name": "Egypt", "dialCode": "+20" },
    { "code": "FR", "name": "France", "dialCode": "+33" },
    { "code": "DE", "name": "Germany", "dialCode": "+49" },
    { "code": "GR", "name": "Greece", "dialCode": "+30" },
    { "code": "IN", "name": "India", "dialCode": "+91" },
    { "code": "ID", "name": "Indonesia", "dialCode": "+62" },
    { "code": "IR", "name": "Iran", "dialCode": "+98" },
    { "code": "IQ", "name": "Iraq", "dialCode": "+964" },
    { "code": "IE", "name": "Ireland", "dialCode": "+353" },
    { "code": "IL", "name": "Israel", "dialCode": "+972" },
    { "code": "IT", "name": "Italy", "dialCode": "+39" },
    { "code": "JP", "name": "Japan", "dialCode": "+81" },
    { "code": "JO", "name": "Jordan", "dialCode": "+962" },
    { "code": "KZ", "name": "Kazakhstan", "dialCode": "+7" },
    { "code": "KE", "name": "Kenya", "dialCode": "+254" },
    { "code": "KR", "name": "South Korea", "dialCode": "+82" },
    { "code": "KW", "name": "Kuwait", "dialCode": "+965" },
    { "code": "LB", "name": "Lebanon", "dialCode": "+961" },
    { "code": "MY", "name": "Malaysia", "dialCode": "+60" },
    { "code": "MX", "name": "Mexico", "dialCode": "+52" },
    { "code": "MA", "name": "Morocco", "dialCode": "+212" },
    { "code": "NL", "name": "Netherlands", "dialCode": "+31" },
    { "code": "NZ", "name": "New Zealand", "dialCode": "+64" },
    { "code": "NG", "name": "Nigeria", "dialCode": "+234" },
    { "code": "NO", "name": "Norway", "dialCode": "+47" },
    { "code": "PK", "name": "Pakistan", "dialCode": "+92" },
    { "code": "PE", "name": "Peru", "dialCode": "+51" },
    { "code": "PH", "name": "Philippines", "dialCode": "+63" },
    { "code": "PL", "name": "Poland", "dialCode": "+48" },
    { "code": "PT", "name": "Portugal", "dialCode": "+351" },
    { "code": "QA", "name": "Qatar", "dialCode": "+974" },
    { "code": "RO", "name": "Romania", "dialCode": "+40" },
    { "code": "RU", "name": "Russia", "dialCode": "+7" },
    { "code": "SA", "name": "Saudi Arabia", "dialCode": "+966" },
    { "code": "SG", "name": "Singapore", "dialCode": "+65" },
    { "code": "ZA", "name": "South Africa", "dialCode": "+27" },
    { "code": "ES", "name": "Spain", "dialCode": "+34" },
    { "code": "SE", "name": "Sweden", "dialCode": "+46" },
    { "code": "CH", "name": "Switzerland", "dialCode": "+41" },
    { "code": "TH", "name": "Thailand", "dialCode": "+66" },
    { "code": "TR", "name": "Turkey", "dialCode": "+90" },
    { "code": "UA", "name": "Ukraine", "dialCode": "+380" },
    { "code": "AE", "name": "United Arab Emirates", "dialCode": "+971" },
    { "code": "GB", "name": "United Kingdom", "dialCode": "+44" },
    { "code": "US", "name": "United States", "dialCode": "+1" },
    { "code": "VN", "name": "Vietnam", "dialCode": "+84" },
    { "code": "YE", "name": "Yemen", "dialCode": "+967" },
    { "code": "ZW", "name": "Zimbabwe", "dialCode": "+263" }
  ]
  
  const { data: unitList } = useGetCompanyCodeTranslationQuery({
    codetype: "UNITS",
  });

  const { data: tcsList } = useGetCompanyCodeTranslationQuery({
    codetype: 2,
  });

  const { data: tdsList } = useGetCompanyCodeTranslationQuery({
    codetype: 1,
  });

  const { data: AccountMasterList } = useListAccountMasterv2Query(undefined, {
    refetchOnMountOrArgChange: true,
  });

  let getCompany = useSelector(
    (state) => state?.companyReducer?.companyDetails
  );

  const { data: ledgerList } = useListAccountMasterv2Query();

  // const {
  //   data: units,
  // } = useGetCodeTranslationQuery({ codetype: "UNITS" });
  const { data: groupData } = useListGroupMasterQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });

  useEffect(() => {
    async function getTDSoptions() {
      const response = await API.graphql(
        graphqlOperation(getPartyAccountData, {
          accountgroupid: 7,
          accountgroupsubid: 7,
          objecttype1: "1",
        })
      );
      setTdsData(() => {
        return (
          response.data?.tds?.map(
            (data) => `${data.codetext} (${data.codevalue}%)`
          ) || []
        );
      });
    }

    async function getLessTds() {
      const res = await API.graphql(
        graphqlOperation(getCompanyCodeTranslation, { codetype: "1" })
      );
      setLessTds(
        res.data?.getCompanyCodeTranslation?.map(
          (data) => `${data.codetext} (${data.codevalue}%)`
        )
      );
    }
    getTDSoptions();
    getLessTds();
  }, []);

  const handleDownloadTemplate = async () => {

    if (!module) {
      const moduleFocus = document.getElementById("combo-box-demo");
      if (moduleFocus) {
        moduleFocus.focus();
      }
      showWarningSnackbar("Please select a module to download");
      return;
    }

    const { workbook, worksheet, hiddenSheet } = createWorkbook(module);

    if (module === "Accounts" || module === "Groups") {
      const options = [
        "Assets",
        "Liabilities",
        "Trading Incomes",
        "Trading Expense",
        "Direct Expense",
        "Direct Income",
        "InDirect Expense",
        "InDirect Income",
      ];
      const options2 = ["Balancesheet", "profit and Loss"];
      const options3 = allGroups?.map((data) => data.accountgroupname);
      addDropdowns("C2:C2", options, worksheet, hiddenSheet, "A");
      addDropdowns("D2:D2", options2, worksheet, hiddenSheet, "B");
      addDropdowns("B2:B2", options3, worksheet, hiddenSheet, "C");
    }
    if (module === "Parties-Customer") {
      const gstCatagoey = [
        "Registered Business - Regular",
        "Registered Business - Composition Scheme",
        "Unregistered Business",
        "Overseas Customer",
        "SEZ (Special Economic Zone)",
      ];
      const legalEntery = [
        "Association of Persons",
        "Body of Individuals",
        "Private Limited Company",
        "Public Limited Company",
        "Firm/Partnership",
        "Government",
        "Hindu Undivided Family",
        "Artificial Juridical Person",
        "Local Authority",
        "Individual",
        "Trust",
        "Limited Liability Partnership",
      ];
      const placeOfSupply = listOfStates?.map((item) => item.statename);
      const billingCurrency = billingCurrencyOptions?.map((data) => data.label);
      const customerGroup = ["Trade Recivables"];
      // const countryList = countryData?.countryList?.getCodeTranslation
      //   ?.map((country) => country.codetext)
      //   .sort((a, b) => a.localeCompare(b));
      // const stateList = stateData?.stateList?.getCodeTranslation
      //   ?.map((state) => state.codetext)
      //   .sort((a, b) => a.localeCompare(b));
      const countryList = countriesList?.map((country) => country.codetext).sort((a, b) => a.localeCompare(b));
      const stateList = []//stateList?.map((state) => state.codetext).sort((a, b) => a.localeCompare(b));



      addDropdowns("B2:B10", gstCatagoey, worksheet);
      addDropdowns("D2:D10", legalEntery, worksheet, hiddenSheet, "A");
      addDropdowns("E2:E10", placeOfSupply, worksheet, hiddenSheet, "B");
      addDropdowns("K2:K10", billingCurrency, worksheet, hiddenSheet, "C");
      addDropdowns("H2:H10", customerGroup, worksheet, hiddenSheet, "D");
      addDropdowns("O2:O10", countryList, worksheet, hiddenSheet, "E");
      addDropdowns("U2:U10", countryList, worksheet, hiddenSheet, "E");
      addDropdowns("Q2:Q10", stateList, worksheet, hiddenSheet, "F");
      addDropdowns("W2:W10", stateList, worksheet, hiddenSheet, "F");
    }
    if (module === "Parties-Supplier") {
      const gstCatagoey = [
        "Registered Business - Regular",
        "Registered Business - Composition Scheme",
        "Unregistered Business",
        "Overseas Customer",
        "SEZ (Special Economic Zone)",
      ];
      const legalEntery = [
        "Association of Persons",
        "Body of Individuals",
        "Private Limited Company",
        "Public Limited Company",
        "Firm/Partnership",
        "Government",
        "Hindu Undivided Family",
        "Artificial Juridical Person",
        "Local Authority",
        "Individual",
        "Trust",
        "Limited Liability Partnership",
      ];
      const placeOfSupply = listOfStates?.map((item) => item.statename);
      const countryList = countriesList?.map((country) => country.codetext).sort((a, b) => a.localeCompare(b));
      const stateLists = stateList?.map((state) => state.codetext).sort((a, b) => a.localeCompare(b));
      const billingCurrency = billingCurrencyOptions?.map((data) => data.label);
      const countryCode = country.map((data) =>(
        `${data.name} ${data.dialCode}`
      ))
      const customerGroup = ["TradePayable"];
      const TDSdata = tdsData;
      const msme = ["Micro", "Small", "Medium"];


      const columns = ['N', 'P', 'AI', 'AK'];

      for (let i = 2; i < 11; i++) {
        columns.forEach(column => {
          worksheet.getCell(`${column}${i}`).dataValidation = {
            type: 'whole',
            operator: 'notEqual',
            showErrorMessage: true,
            formulae: [0],
            errorStyle: 'error',
            errorTitle: 'Number',
            error: 'Should be a number',
            // showInputMessage: true,
            // promptTitle: 'PHONE NUMBER',
            // prompt: 'SHOULD BE A PHONE NUMBER'
          };
        });
      }

      addDropdowns("B2:B10", gstCatagoey, worksheet);
      addDropdowns("D2:D10", legalEntery, worksheet, hiddenSheet, "A");
      addDropdowns("E2:E10", placeOfSupply, worksheet, hiddenSheet, "B");
      addDropdowns("K2:K10", billingCurrency, worksheet, hiddenSheet, "C");
      addDropdowns("M2:M10", countryCode, worksheet, hiddenSheet, "I")
      addDropdowns("O2:O10", countryCode, worksheet, hiddenSheet, "I")
      addDropdowns("H2:H10", customerGroup, worksheet, hiddenSheet, "D");
      addDropdowns("Y2:Y10", TDSdata, worksheet, hiddenSheet, "E");
      addDropdowns("X2:X10", msme, worksheet, hiddenSheet, "F");
      addDropdowns("Z2:Z10", countryList, worksheet, hiddenSheet, "G");
      addDropdowns("Q2:Q10", countryList, worksheet, hiddenSheet, "G");
      addDropdowns("S2:S10", stateLists, worksheet, hiddenSheet, "H");
      addDropdowns("AB2:AB10", stateLists, worksheet, hiddenSheet, "H");
      addDropdowns("AH2:AH10", countryCode, worksheet, hiddenSheet, "I");
      addDropdowns("AJ2:AJ10", countryCode, worksheet, hiddenSheet, "I");
    }
    if (module === "Item") {
      const itemType = ["GOODS", "SERVICE"];
      const itemCaterory = ["GOODS", "SERVICE"];
      const measureUnit = unitList?.map((data) => data.codetext);
      const taxability =
        getCompany.relatedcompanydetailsnew?.registrationtype === "3"
          ? [
              "Taxable - Composition",
              "Exempted",
              "Non-Taxable(Non-GST)",
              "Out of scope",
            ]
          : [
              "Taxable",
              "Exempted",
              "Non-Taxable(Non-GST)",
              "GST Reverse Charge",
              "Out of scope",
            ];
      const billingCurrency = billingCurrencyOptions?.map((data) => data.label);
      const priceType = ["Wholesale", "Retail"];
      const discountType = ["₹", "%"];
      const gdtRate = ["0%", "5%", "12%", "18%", "28%"];
      const underCategory = ledgerList
        ?.map((data) => data.accountname)
        .sort((a, b) => a.localeCompare(b));

      addDropdowns("C2:C10", itemType, worksheet, hiddenSheet, "A");
      addDropdowns("D2:D10", itemCaterory, worksheet, hiddenSheet, "B");
      addDropdowns("E2:E10", measureUnit, worksheet, hiddenSheet, "C");
      addDropdowns("F2:F10", underCategory, worksheet, hiddenSheet, "K");
      addDropdowns("G2:G10", underCategory, worksheet, hiddenSheet, "L");
      addDropdowns("I2:I10", taxability, worksheet, hiddenSheet, "D");
      // addDropdowns("J2:J10", billingCurrency, worksheet, hiddenSheet, "E");
      addDropdowns("J2:J10", priceType, worksheet, hiddenSheet, "F");
      addDropdowns("L2:L10", discountType, worksheet, hiddenSheet, "G");
      addDropdowns("N2:N10", gdtRate, worksheet, hiddenSheet, "H");
      addDropdowns("R2:R10", discountType, worksheet, hiddenSheet, "I");
      addDropdowns("T2:T10", gdtRate, worksheet, hiddenSheet, "J");
    }
    if (module === "Sales") {
      const placeOfSupply = listOfStates?.map((item) => item.statename);
      const billingCurrency = billingCurrencyOptions?.map((data) => data.label);
      const taxability =
        getCompany?.relatedcompanydetailsnew?.registrationtype === "3"
          ? [
              "Taxable - Composition",
              "Exempted",
              "Non-Taxable(Non-GST)",
              "Out of scope",
            ]
          : [
              "Taxable",
              "Exempted",
              "Non-Taxable(Non-GST)",
              "GST Reverse Charge",
              "Out of scope",
            ];
      const priceType = ["Wholesale", "Retail"];
      const gdtRate = ["0%", "5%", "12%", "18%", "28%"];
      const measureUnit = unitList?.map((data) => data.codetext);
      const underCategory = ledgerList
        ?.map((data) => data.accountname)
        .sort((a, b) => a.localeCompare(b));
      const discountType = ["₹", "%"];
      const tcsOptions = tcsList?.map(
        (data) => `${data.codetext}(${data.codevalue}%)`
      );
      const transMode = ["Railways", "Air", "Road", "Ship"];

      addDropdowns("E2:E10", placeOfSupply, worksheet, hiddenSheet, "A");
      addDropdowns("G2:G10", billingCurrency, worksheet, hiddenSheet, "B");
      addDropdowns("K2:K10", taxability, worksheet, hiddenSheet, "C");
      addDropdowns("N2:N10", priceType, worksheet, hiddenSheet, "D");
      addDropdowns("N2:N10", priceType, worksheet, hiddenSheet, "E");
      addDropdowns("O2:O10", gdtRate, worksheet, hiddenSheet, "F");
      addDropdowns("R2:R10", measureUnit, worksheet, hiddenSheet, "G");
      addDropdowns("Y2:Y10", underCategory, worksheet, hiddenSheet, "H");
      addDropdowns("Z2:Z10", gdtRate, worksheet, hiddenSheet, "F");
      addDropdowns("AF2:AF10", discountType, worksheet, hiddenSheet, "I");
      addDropdowns("AH2:AH10", tcsOptions, worksheet, hiddenSheet, "J");
      addDropdowns("AP2:AP10", transMode, worksheet, hiddenSheet, "K");
    }
    if (module === "Purchase") {
      const placeOfSupply = listOfStates?.map((item) => item.statename);
      const billingCurrency = billingCurrencyOptions?.map((data) => data.label);
      const taxability =
        getCompany.relatedcompanydetailsnew?.registrationtype === "3"
          ? [
              "Taxable - Composition",
              "Exempted",
              "Non-Taxable(Non-GST)",
              "Out of scope",
            ]
          : [
              "Taxable",
              "Exempted",
              "Non-Taxable(Non-GST)",
              "GST Reverse Charge",
              "Out of scope",
            ];
      const priceType = ["Wholesale", "Retail"];
      const gdtRate = ["0%", "5%", "12%", "18%", "28%"];
      const measureUnit = unitList?.map((data) => data.codetext);
      const underCategory = ledgerList
        ?.map((data) => data.accountname)
        .sort((a, b) => a.localeCompare(b));
      const tcsOptions = tcsList?.map(
        (data) => `${data.codetext}(${data.codevalue}%)`
      );
      const tdsOptions = tdsList?.map(
        (data) => `${data.codetext}(${data.codevalue}%)`
      );
      const discountType = ["₹", "%"];

      addDropdowns("D2:D10", placeOfSupply, worksheet, hiddenSheet, "A");
      addDropdowns("F2:F10", billingCurrency, worksheet, hiddenSheet, "B");
      addDropdowns("J2:J10", taxability, worksheet, hiddenSheet, "C");
      addDropdowns("M2:M10", priceType, worksheet, hiddenSheet, "D");
      addDropdowns("N2:N10", gdtRate, worksheet, hiddenSheet, "E");
      addDropdowns("Q2:Q10", measureUnit, worksheet, hiddenSheet, "F");
      addDropdowns("Y2:Y10", underCategory, worksheet, hiddenSheet, "G");
      addDropdowns("Z2:Z10", gdtRate, worksheet, hiddenSheet, "H");
      addDropdowns("AJ2:AJ10", tdsOptions, worksheet, hiddenSheet, "I");
      addDropdowns("AM2:AM10", tcsOptions, worksheet, hiddenSheet, "J");
      addDropdowns("AH2:AH10", discountType, worksheet, hiddenSheet, "K");
    }
    if (module === "Debit Note" || module === "Credit Note") {
      const placeOfSupply = listOfStates?.map((item) => item.statename);
      const billingCurrency = billingCurrencyOptions?.map((data) => data.label);
      const taxability =
        getCompany.relatedcompanydetailsnew?.registrationtype === "3"
          ? [
              "Taxable - Composition",
              "Exempted",
              "Non-Taxable(Non-GST)",
              "Out of scope",
            ]
          : [
              "Taxable",
              "Exempted",
              "Non-Taxable(Non-GST)",
              "GST Reverse Charge",
              "Out of scope",
            ];
      const gdtRate = ["0%", "5%", "12%", "18%", "28%"];
      const measureUnit = unitList?.map((data) => data.codetext);
      const underCategory = ledgerList
        ?.map((data) => data.accountname)
        .sort((a, b) => a.localeCompare(b));
      const discountType = ["₹", "%"];
      const tcsOptions = tcsList?.map(
        (data) => `${data.codetext}(${data.codevalue}%)`
      );
      const tdsOptions = tdsList?.map(
        (data) => `${data.codetext}(${data.codevalue}%)`
      );
      const transMode = ["Railways", "Air", "Road", "Ship"];

      addDropdowns("E2:E10", placeOfSupply, worksheet, hiddenSheet, "A");
      addDropdowns("G2:G10", billingCurrency, worksheet, hiddenSheet, "B");
      addDropdowns("J2:J10", taxability, worksheet, hiddenSheet, "C");
      addDropdowns("N2:N10", gdtRate, worksheet, hiddenSheet, "D");
      addDropdowns("Q2:Q10", measureUnit, worksheet, hiddenSheet, "E");
      addDropdowns("U2:U10", underCategory, worksheet, hiddenSheet, "F");
      addDropdowns("W2:W10", gdtRate, worksheet, hiddenSheet, "D");
      addDropdowns("AB2:AB10", discountType, worksheet, hiddenSheet, "J");
      addDropdowns("AD2:AD10", tdsOptions, worksheet, hiddenSheet, "G");
      addDropdowns("AE2:AE10", tcsOptions, worksheet, hiddenSheet, "H");
      addDropdowns("AG2:AG10", transMode, worksheet, hiddenSheet, "I");
    }
    if (module === "Payment Voucher" || module == "Receipt Voucher") {
      const paymentFrom = ["Cash", "Bank"];
      const paidTo = AccountMasterList?.map((data) => data.accountname).sort(
        (a, b) => a.localeCompare(b)
      );
      const lessTdsData = lessTds.sort((a, b) => a.localeCompare(b));

      addDropdowns("A2:A10", paymentFrom, worksheet, hiddenSheet, "A");
      addDropdowns("E2:E10", paidTo, worksheet, hiddenSheet, "B");
      addDropdowns("G2:G10", lessTdsData, worksheet, hiddenSheet, "C");
    }
    if (module === "Journal Entries") {
      const paidTo = AccountMasterList?.map((data) => data.accountname).sort(
        (a, b) => a.localeCompare(b)
      );

      addDropdowns("C2:C10", paidTo, worksheet, hiddenSheet, "A");
    }
    addTable(worksheet, fields);
    applyStyling(worksheet, fields);
    await downloadWorkbook(workbook, module, format);
  };

  return (
    <Box sx={{ marginBottom: 3 }}>
      <Typography variant="subtitle1">
        Click the below button to download the data import template
      </Typography>

      <Button
        onClick={handleDownloadTemplate}
        variant="outlined"
        startIcon={<GetAppIcon />}
      >
        Download Template.
      </Button>
    </Box>
  );
}

export default TemplateGenerator;
